import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import HotspotsFloatElement from '../float-element/hotspots-float-element'
import HeaderComponent from '../header/header'
import Modal from '../modal/modal'

class Hotspots extends BaseComponent {
  modals: Modal[]
  floatElements: HotspotsFloatElement[]
  header: Nullable<HeaderComponent>

  constructor() {
    super()

    this.modals = [...this.querySelectorAll('modal-component')] as Modal[]
    this.floatElements = [
      ...this.querySelectorAll('hotspots-float-element'),
    ] as HotspotsFloatElement[]
    this.floatElementsBtns = [
      ...this.querySelectorAll('float-element-btn'),
    ] as HotspotsFloatElement[]
    this.header = document.querySelector('header-component')
  }

  connectedCallback(): void {
    this.modals.forEach(modal => {
      customElements.whenDefined('modal-component').then(() => {
        modal.subscribe('show', this.handleModalOpen)
        modal.subscribe('hide', this.handleModalHide)
      })
    })

    this.floatElements.forEach(floatElement => {
      customElements.whenDefined('hotspots-float-element').then(() => {
        floatElement.subscribe('hide', this.handleFloatElementHide)
        floatElement.subscribe('show', this.handleFloatElementShow)
      })
    })

    this.floatElementsBtns.forEach(btn => {
      btn?.addEventListener('mouseenter', this.handlePinBtnEnter)
      btn?.addEventListener('mouseleave', this.handlePinBtnLeave)
      btn?.addEventListener('click', this.handlePinBtnClick)
    })

    if (this.isEditorMode) {
      window.addEventListener('click', this.handleEditorClick)
    }
  }

  disconnectedCallback(): void {
    this.modals.forEach(modal => {
      customElements.whenDefined('modal-component').then(() => {
        modal.unsubscribe('show', this.handleModalOpen)
        modal.unsubscribe('hide', this.handleModalHide)
      })
    })

    this.floatElements.forEach(floatElement => {
      customElements.whenDefined('hotspots-float-element').then(() => {
        floatElement.unsubscribe('hide', this.handleFloatElementHide)
        floatElement.unsubscribe('show', this.handleFloatElementShow)
      })
    })

    this.floatElementsBtns.forEach(btn => {
      btn?.removeEventListener('mouseenter', this.handlePinBtnEnter)
      btn?.removeEventListener('mouseleave', this.handlePinBtnLeave)
      btn?.removeEventListener('click', this.handlePinBtnClick)
    })

    if (this.isEditorMode) {
      window.removeEventListener('click', this.handleEditorClick)
    }
  }

  handlePinBtnClick = (event: MouseEvent): void => {
    this.setAttribute('animation-state', 'pause')
  }

  handlePinBtnEnter = (event: MouseEvent): void => {
    this.setAttribute('animation-state', 'pause')
  }

  handlePinBtnLeave = (event: MouseEvent): void => {
    if (this.hasOpenFloatElement) {
      return
    }

    this.removeAttribute('animation-state')
  }

  handleFloatElementShow = () => {
    this.hasOpenFloatElement = true
  }

  handleFloatElementHide = () => {
    this.hasOpenFloatElement = false

    this.removeAttribute('animation-state')
  }

  handleModalOpen = (): void => {
    this.setAttribute('animation-state', 'pause')

    if (this.header) {
      this.header.setHidden(true)
    }
  }

  handleModalHide = (): void => {
    this.removeAttribute('animation-state')

    if (this.header) {
      this.header.setHidden(false)
    }
  }

  handleEditorClick = (event: MouseEvent): void => {
    const isTriggerBtn = event.target?.closest('float-element-btn')
    const isFloatElement = event.target?.closest('hotspots-float-element')

    if (isTriggerBtn || isFloatElement) {
      return
    }

    this.floatElements.forEach(floatElement => {
      floatElement.hide()
    })
  }
}

export default Hotspots
